import { Button, Typography } from "@mui/material";
import { NoDataWrapper } from "../style";
import { useCallback, useMemo } from "react";
import { useDialog } from "helper/customHook";
import { DIALOG } from "helper/enum/dialogEnum";
import { useDispatch, useSelector } from "react-redux";
import { setupFeedback } from "modules/DeclareLeave/redux/sendFeedback";
import { TYPE_LEAVE } from "modules/DeclareLeave/redux/getReasonLeave";
import moment from "moment";
import { getFeedbackDetailStart } from "modules/DeclareLeave/redux/getFeedbackDetail";
import { SCREEN } from "helper/roleChecker/Screens";
import { roleMenuDataSelector } from "layouts/Sidenav/redux/selector";

const IExplainStatus = {
  PENDING: "PENDING",
  REFUSE: "REFUSE",
  APPROVE: "APPROVE",
  AUTO_APPROVE: "AUTO_APPROVE",
  AUTO_REFUSE: "AUTO_REFUSE",
};

type ExplainStatus = keyof typeof IExplainStatus;
export interface MissDataProps {
  day: moment.Moment;
  explainAllow: TYPE_LEAVE | null;
  explainStatus: ExplainStatus | null;
  explainEditable: boolean;
  noData: boolean;
  id: string;
}

export const MissData = ({
  day,
  explainAllow,
  explainStatus,
  explainEditable,
  noData,
  id,
}: MissDataProps) => {
  const sendFeedbackDialog = useDialog(DIALOG.SEND_FEEDBACK);
  const viewFeedbackDetailDialog = useDialog(DIALOG.RESPONSE_DETAIL);
  const role = useSelector(roleMenuDataSelector);

  const dispatch = useDispatch();
  const handleClickSendFeedback = useCallback(() => {
    dispatch(
      setupFeedback({
        id,
        date: moment(day, "DD/MM/YYYY").format("DD/MM/YYYY"),
        explainAllow: explainAllow,
      })
    );
    sendFeedbackDialog.open();
  }, [day, dispatch, explainAllow, id, sendFeedbackDialog]);

  const viewDetail = useCallback(() => {
    if (id) {
      dispatch(getFeedbackDetailStart({ screenCode: SCREEN.IP_016, id }));
      viewFeedbackDetailDialog.open();
    } else {
    }
  }, [dispatch, id, viewFeedbackDetailDialog]);

  const renderContent = useMemo(() => {
    switch (explainStatus) {
      case null:
        return (
          <NoDataWrapper>
            {noData && (
              <Typography
                fontSize={12}
                sx={(theme) => ({
                  color: theme.palette.text.textPrimary,
                  textAlign: "left",
                })}
              >
                Không có dữ liệu
              </Typography>
            )}
            <Button
              variant="outlined"
              color="primary"
              sx={{
                fontSize: 12,
                ":disabled": {
                  border: "none",
                },
              }}
              fullWidth
              onClick={handleClickSendFeedback}
              disabled={!explainEditable}
            >
              Gửi phản hồi
            </Button>
          </NoDataWrapper>
        );
      default:
        return (
          <NoDataWrapper>
            <Button
              variant="outlined"
              color="primary"
              sx={{ fontSize: 12 }}
              fullWidth
              onClick={viewDetail}
              disabled={!role?.includes(SCREEN.IP_016)}
            >
              Đã gửi phản hồi
            </Button>
          </NoDataWrapper>
        );
    }
  }, [
    explainEditable,
    explainStatus,
    handleClickSendFeedback,
    noData,
    role,
    viewDetail,
  ]);

  return explainAllow ? renderContent : <></>;
};
